import { defineAsyncComponent } from 'vue'
export default {
  area: defineAsyncComponent(() => import("/tmp/tmpgl07msmh/layouts/area.vue").then(m => m.default || m)),
  point: defineAsyncComponent(() => import("/tmp/tmpgl07msmh/layouts/point.vue").then(m => m.default || m)),
  pref: defineAsyncComponent(() => import("/tmp/tmpgl07msmh/layouts/pref.vue").then(m => m.default || m)),
  ranking: defineAsyncComponent(() => import("/tmp/tmpgl07msmh/layouts/ranking.vue").then(m => m.default || m)),
  top: defineAsyncComponent(() => import("/tmp/tmpgl07msmh/layouts/top.vue").then(m => m.default || m))
}